import { Address } from '../codegen/transactions';

export const FormattedAddress = ({
  street,
  zipCode,
  city,
  country,
  state,
}: Address) => (
  <>
    <div>{street}</div>
    <div>
      {zipCode} {city}
    </div>
    {state && <div>{state}</div>}
    <div>{country}</div>
  </>
);
